// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".caption[data-v-4f41b1cf]{text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
